import React, {
	useEffect, useState
}from "react"
import {
	Table, Pagination, Tag
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	managementActions
}from "../store/actions"
import LocalLoading from "../../../components/Loading/Local"
import Search from "./search"
import i18n from "./localization"
import i18nGlobal from "../../../localization"
import "antd/lib/table/style/index.css"
import moment from 'moment'
import '../../../pagination.css'
import "antd/lib/tag/style/index.css"
import "./style.css"
import history from "../../../helpers/history"

const { Column } = Table
const PageSize = 10

const OrgUsers = ({ hideSearch, tab }) => {
	const dispatch = useDispatch()
	const [page, setPage] = useState(1)
	const [searchValues, setSearchValues] = useState({})
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const { orgUsers } = useSelector((state) => state.managementReducer)
	useEffect(() => {
		dispatch(managementActions.getOrgUsers({
			...searchValues,
			page     : page,
			pageSize : PageSize
		}))
	}, [page])

	const onFinish = (data) => {
		data = {
			...data,
			finishDate : data.regDate && data.regDate[1],
			startDate  : data.regDate && data.regDate[0]
		}
		setSearchValues(data)
		dispatch(managementActions.getOrgUsers(data))
	}

	const getParsedData = () => {
		return orgUsers.items.map((e) => {
			return {
				fio              : `${ e.firstName ?? '' } ${ e.middleName ?? '' } ${ e.lastName ?? '' }`,
				id               : e.id,
				isLockout        : e.isLockout,
				isTempAdmin      : e.roles.includes("tempExternalAdmin"),
				position         : e[isRu ? "positionName" : "positionNameBel"] ?? '',
				registrationDate : moment(e.registrationDate).format('DD.MM.YYYY'),
				unit             : e[isRu ? "unitName" : "unitNameBel"],
				userName         : e.userName
			}
		})
	}

	const getColumn = (title, key) => {
		return (
			<Column
				key={ key }
				dataIndex={ key }
				title={ title }
			/>
		)
	}

	const getPositionColumn = (title, position, unit) => {
		return (
			<Column
				key={ position }
				dataIndex={ position }
				render={ (positionValue, record) => {
					return `${ positionValue } ${ (record[unit] ? `(${ record[unit] })` : ``) }`.trim()
				} }
				title={ title }
			/>
		)
	}

	return (
		<>
			{ hideSearch && <Search
				tab={ tab }
				onFinish={ onFinish }
			                /> }
			{ orgUsers ? (
				<>
					<Table
						className="org-users-table"
						dataSource={ getParsedData() }
						pagination={ false }
						onRow={ (record) => {
							return {
								onDoubleClick: event => {
									history.push(`/orgUsers/${ record.id }`)
								}
							}
						} }
					>
						{ getPositionColumn(i18nGlobal.position[isRu], "position", "unit") }
						{ getColumn(i18nGlobal.fio[isRu], "fio") }
						{ getColumn(i18n.registrationDate[isRu], "registrationDate") }
					</Table>
					<Pagination
						current={ orgUsers.page }
						pageSize={ PageSize }
						showSizeChanger={ false }
						total={ orgUsers.count }
						onChange={ (value) => setPage(value) }
					/>
				</>
			) : (
				<LocalLoading />
			) }
		</>
	)
}

export default OrgUsers
